import React from 'react';
import { MathJax, MathJaxContext } from 'better-react-mathjax';

const config = {
  loader: { load: ['input/tex', 'output/chtml'] },
  tex: {
    inlineMath: [['$', '$'], ['\\(', '\\)']],
    displayMath: [['\\[', '\\]']],
  }
};

export default function MathJaxTest() {
  return (
    <MathJaxContext config={config}>
      <div className="p-6 max-w-2xl mx-auto bg-white shadow rounded">
        <p className="mb-4 text-gray-800 text-sm">
          Below is a math expression rendered with MathJax:
        </p>
        <MathJax dynamic>
          {"\\[ E(R) = (0.2 \\times 5) + (0.5 \\times 10) + (0.3 \\times 15) = 10.5\\% \\]"}
        </MathJax>
      </div>
    </MathJaxContext>
  );
}
